import { get, flow, orderBy, filter } from 'lodash/fp';
import { createSelector } from 'reselect';
import optionValuesToLabels from '../../../../../helpers/optionValuesToLabels';
import { Status as TrackingMethodStatus } from '../../../../../constants/tracking-method';

export const getSearchOptions = get('inventory.components.searchOptions');

export const getItemTagsSearchOptions = createSelector(
  getSearchOptions,
  get('itemTags.options')
);

export const getIsFetchingItemTagsOptions = flow(
  getSearchOptions,
  get('itemTags.fetching')
);

export const getIsFetchedItemTagsOptions = flow(
  getSearchOptions,
  get('itemTags.fetched')
);

export const getPackageTagsSearchOptions = createSelector(
  getSearchOptions,
  get('packageTags.options')
);

export const getIsFetchingPackageTagsOptions = flow(
  getSearchOptions,
  get('packageTags.fetching')
);

export const getIsFetchedPackageTagsOptions = flow(
  getSearchOptions,
  get('packageTags.fetched')
);

export const getItemAvailabilityLocationZonesOptions = createSelector(
  getSearchOptions,
  get('itemAvailabilityLocationZones.options')
);

export const getIsFetchingItemAvailabilityLocationZonesOptions = flow(
  getSearchOptions,
  get('itemAvailabilityLocationZones.fetching')
);

export const getIsFetchedItemAvailabilityLocationZonesOptions = flow(
  getSearchOptions,
  get('itemAvailabilityLocationZones.fetched')
);

export const getPackageAvailabilityLocationsOptions = createSelector(
  getSearchOptions,
  get('packageAvailabilityLocations.options')
);

export const getIsFetchingPackageAvailabilityLocationsOptions = flow(
  getSearchOptions,
  get('packageAvailabilityLocations.fetching')
);

export const getIsFetchedPackageAvailabilityLocationsOptions = flow(
  getSearchOptions,
  get('packageAvailabilityLocations.fetched')
);

export const getTrackingMethodsOptions = createSelector(
  getSearchOptions,
  flow(
    get('trackingMethods.options'),
    orderBy('label', 'asc')
  )
);

export const getActiveTrackingMethodsOptions = createSelector(
  getTrackingMethodsOptions,
  filter({ meta: { status: TrackingMethodStatus.ACTIVE } })
);

export const trackingMethodOptionValuesToLabels = createSelector(
  (_, values) => values,
  getTrackingMethodsOptions,
  optionValuesToLabels
);

export const getIsFetchingTrackingMethodsOptions = flow(
  getSearchOptions,
  get('trackingMethods.fetching')
);

export const getIsFetchedTrackingMethodsOptions = flow(
  getSearchOptions,
  get('trackingMethods.fetched')
);
